<template>
  <authStepsLayout :step="status === 'success' ? 3 : 2">
    <div class="verify">
      <template v-if="status === 'pending'">
        <v-progress-circular indeterminate color="primary" size="56" />
        <h2 class="verify__title mt-6">{{ $t("login.verifying") }}</h2>
      </template>

      <template v-else-if="status === 'success'">
        <v-icon color="primary" size="64">mdi-check-circle-outline</v-icon>
        <h2 class="verify__title mt-4">{{ $t("login.verifiedHeading") }}</h2>
        <p class="verify__text">{{ $t("login.verifiedText") }}</p>
        <v-btn color="primary" min-width="200" class="mt-6" @click="goToLogin">
          {{ $t("login.toLogin") }}
        </v-btn>
      </template>

      <template v-else>
        <v-icon color="error" size="64">mdi-alert-circle-outline</v-icon>
        <h2 class="verify__title mt-4">{{ $t("login.verifyFailedHeading") }}</h2>
        <p class="verify__text">{{ $t("login.verifyFailedText") }}</p>
        <v-btn color="primary" min-width="200" class="mt-6" @click="goToLogin">
          {{ $t("login.toLogin") }}
        </v-btn>
      </template>
    </div>
  </authStepsLayout>
</template>
<script>
import authStepsLayout from "../../components/layout/authStepsLayout.vue";

export default {
  components: { authStepsLayout },
  data() {
    return {
      status: "pending",
    };
  },
  mounted() {
    const token = this.$route.params.token;
    if (!token) {
      this.status = "error";
      return;
    }
    this.$store.dispatch("confirmRegistration", token).then((ok) => {
      this.status = ok ? "success" : "error";
    });
  },
  methods: {
    goToLogin() {
      this.$router.push("/login/login/1/1/1");
    },
  },
};
</script>
<style scoped>
.verify {
  text-align: center;
  padding: 16px 0;
}
.verify__title {
  font-family: Roboto, sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 100%;
  color: #1a5561;
}
.verify__text {
  margin-top: 16px;
  font-size: 16px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.6);
}
</style>
